/** @jsx jsx */
import { jsx, Container, Box } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import {
  SectionComponent,
  FluidImage as ImageType,
} from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { CTA } from '../../@types/cta';

// Components
import CTAButton from '../../components/ctaButton';
import Text, { TEXT_TYPES } from '../../components/text';

// Helpers
import { nl2br } from '../../helpers/general';

// Styles
import * as style from './style';

interface TitleTextCtaBgProps extends Section {
  background: {
    image?: ImageType;
  };
  cta: CTA;
  title: {
    title: string;
  };
  textAlignment: {
    textAlignment: string;
  };
  text: {
    text?: string;
  };
  sectionWidth: {
    sectionWidth: string;
  };
  sectionTextColor: {
    sectionTextColor: string;
  };
}

const TitleTextCtaBg: SectionComponent<TitleTextCtaBgProps> = React.memo(
  ({
    background,
    cta,
    title,
    textAlignment,
    text,
    sectionTextColor,
    sectionWidth,
    isFirst,
  }) => {
    // Helpers
    const containerWidthStyle =
      sectionWidth.sectionWidth === 'restricted' && style.RestrictedContainer;
    const containerTextAlignment =
      textAlignment.textAlignment === 'center' &&
      style.ContainerWithCenteredText;

    const containerTextColor =
      sectionTextColor.sectionTextColor === 'light' &&
      style.ContainerWithLightText;

    const pathname = (typeof window !== 'undefined'
      ? window.location.pathname
      : '/'
    ).replace(/\//g, '');

    return (
      <Box
        sx={
          background?.image?.localFile?.publicURL
            ? {
                backgroundImage: `url('${background?.image?.localFile?.publicURL}')`,
              }
            : null
        }
      >
        <Container
          sx={{
            ...style.BaseContainer,
            ...containerWidthStyle,
            ...containerTextAlignment,
            ...containerTextColor,
          }}
          className={pathname}
        >
          <Text type={isFirst ? TEXT_TYPES.H1_BOLD : TEXT_TYPES.H2}>
            {title.title}
          </Text>
          <Text type={TEXT_TYPES.H5} sx={style.Subtitle}>
            <span
              dangerouslySetInnerHTML={{ __html: nl2br(text.text || '') }}
            />
          </Text>
          <CTAButton cta={cta} type="link" sx={style.Cta}>
            {cta.label}
          </CTAButton>
        </Container>
      </Box>
    );
  },
);

export default TitleTextCtaBg;
